export const tag = (theme) => ({
    variants: {
        default: {
            full: {
                backgroundColor: theme.colors?.component.utility.gray[600],
                color: theme.colors?.text.basic.onColor,
            },
            light: {
                backgroundColor: theme.colors?.component.utility.gray[200],
                color: theme.colors?.text.basic.secondary,
            },
            bordered: {
                backgroundColor: 'transparent',
                color: theme.colors?.text.basic.secondary,
                border: `1px solid ${theme.colors?.border.default}`,
                dot: theme.colors?.foreground.subtle,
            },
        },
        error: {
            full: {
                backgroundColor: theme.colors?.component.utility.red[700],
                color: theme.colors?.text.basic.onColor,
            },
            light: {
                backgroundColor: theme.colors?.component.utility.red[100],
                color: theme.colors?.component.utility.red[700],
            },
            bordered: {
                backgroundColor: 'transparent',
                color: theme.colors?.text.basic.secondary,
                border: `1px solid ${theme.colors?.border.default}`,
                dot: theme.colors?.component.utility.red[700],
            },
        },
        negative: {
            full: {
                backgroundColor: theme.colors?.component.utility.red[500],
                color: theme.colors?.text.basic.onColor,
            },
            light: {
                backgroundColor: theme.colors?.component.utility.red[100],
                color: theme.colors?.component.utility.red[600],
            },
            bordered: {
                backgroundColor: 'transparent',
                color: theme.colors?.text.basic.secondary,
                border: `1px solid ${theme.colors?.border.default}`,
                dot: theme.colors?.component.utility.red[500],
            },
        },
        warning: {
            full: {
                backgroundColor: theme.colors?.component.utility.orange[500],
                color: theme.colors?.text.basic.onColor,
            },
            light: {
                backgroundColor: theme.colors?.component.utility.orange[100],
                color: theme.colors?.component.utility.orange[500],
            },
            bordered: {
                backgroundColor: 'transparent',
                color: theme.colors?.text.basic.secondary,
                border: `1px solid ${theme.colors?.border.default}`,
                dot: theme.colors?.component.utility.orange[500],
            },
        },
        caution: {
            full: {
                backgroundColor: theme.colors?.component.utility.yellow[400],
                color: theme.colors?.text.basic.onColorAlt,
            },
            light: {
                backgroundColor: theme.colors?.component.utility.yellow[100],
                color: theme.colors?.component.utility.yellow[600],
            },
            bordered: {
                backgroundColor: 'transparent',
                color: theme.colors?.text.basic.secondary,
                border: `1px solid ${theme.colors?.border.default}`,
                dot: theme.colors?.component.utility.yellow[500],
            },
        },
        positive: {
            full: {
                backgroundColor: theme.colors?.component.utility.green[500],
                color: theme.colors?.text.basic.onColor,
            },
            light: {
                backgroundColor: theme.colors?.component.utility.green[100],
                color: theme.colors?.text.positive,
            },
            bordered: {
                backgroundColor: 'transparent',
                color: theme.colors?.text.basic.secondary,
                border: `1px solid ${theme.colors?.border.default}`,
                dot: theme.colors?.component.utility.green[500],
            },
        },
        info: {
            full: {
                backgroundColor: theme.colors?.component.utility.blue[500],
                color: theme.colors?.text.basic.onColor,
            },
            light: {
                backgroundColor: theme.colors?.component.utility.blue[100],
                color: theme.colors?.text.information,
            },
            bordered: {
                backgroundColor: 'transparent',
                color: theme.colors?.text.basic.secondary,
                border: `1px solid ${theme.colors?.border.default}`,
                dot: theme.colors?.component.utility.blue[500],
            },
        },
    },
});
//# sourceMappingURL=tag.js.map